import { Avatar, Box, Grid2, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import React from "react";
import { useLocation } from "react-router-dom";
import AlertCircleIco from "../../../../../assets/icons/AlertCircleIco";
import CheckIco from "../../../../../assets/icons/CheckIco";
import { HandleSkeletion } from "../../../../../utils/constants";
import { CommonGrid2 } from "../../../../common-components/StyledComponents";
import { CustomPaper } from "../../../../resume-intelligence/Style";
import Comparison from "./Comparison";
import { CustomDiv } from "../../../../chat-bot/style";

function SkillRating({ label, score, handleScoreChange }) {
  const color = score >= 75 ? "#47CD89" : score >= 30 ? "#FDB022" : "red";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mx={1.5}
      sx={{ cursor: handleScoreChange ? "pointer" : "auto" }}
      onClick={() => handleScoreChange && handleScoreChange(label)}
    >
      <Gauge
        width={90}
        height={90}
        value={score}
        cornerRadius="50%"
        text={({ value }) => `${value}%`}
        sx={{
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: 14,
            color: "#101828",
            fontWeight: 600,
          },
          [`& .${gaugeClasses.valueArc}`]: {
            fill: color,
          },
        }}
      />
      <Typography sx={{ fontSize: "12px", color: "#475467", fontWeight: 500 }}>
        {label}
      </Typography>
    </Box>
  );
}

function FeedbackCard({ icon, message, marginBottom }) {
  return (
    // <CustomPaper
    //   variant="outlined"
    //   width="100%"
    //   padding={"12px"}
    //   marginBottom={marginBottom}
    //   display={"flex"}
    //   alignItems={"start"}
    // >
    //   <Avatar
    //     sx={{
    //       bgcolor: "transparent",
    //       marginRight: "4px",
    //       height: "25px !important",
    //     }}
    //   >
    //     {icon}
    //   </Avatar>
    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: 500,
        color: "#667085",
        fontSize: "15px",
        fontWeight: 500,
        color: "#667085",
        padding: "12px",
      }}
    >
      {message}
    </Typography>
    // </CustomPaper>
  );
}

function MatchingSummary({ matchedData, handleScoreChange, loading }) {
  const scoreData = [
    { label: "Overall", score: 96 },
    { label: "Key Skills", score: 80 },
    { label: "Experience", score: 88 },
    { label: "Cultural Fit", score: 94 },
    { label: "Resume", score: 72 },
  ];

  const { pathname } = useLocation(); // Fix the pathname retrieval here

  return (
    <Box>
      <CustomPaper
        variant="outlined"
        width="100%"
        padding={"24px 12px"}
        marginBottom={"16px"}
      >
        <Grid2
          container
          justifyContent="center"
          alignItems={"center"}
          spacing={2}
        >
          <CommonGrid2
            item
            display={"flex"}
            size={{ xs: 12, md: 12, sm: 12 }}
            container
            justifyContent={"center"}
            spacing={0}
          >
            {loading
              ? Array.from({ length: 5 }).map((_, index) => (
                  <HandleSkeletion
                    key={index}
                    height={100}
                    width={100}
                    marginRight={"1rem"}
                  />
                ))
              : scoreData.map((item, index) => (
                  <Grid2 item key={index}>
                    <SkillRating
                      label={item.label}
                      score={item.score}
                      handleScoreChange={handleScoreChange}
                    />
                  </Grid2>
                ))}
          </CommonGrid2>

          {/* Correct conditional rendering for Comparison */}
          {/* {pathname && !pathname.includes("/compare") && (
            <Grid2 item size={{ xs: 12, md: 5, sm: 12 }}>
              <Comparison />
            </Grid2>
          )} */}
        </Grid2>
      </CustomPaper>

      <CommonGrid2 container spacing={3}>
        <CommonGrid2 style={{ paddingTop: "32px" }}>
          <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              padding={"7px"}
              borderBottom={"1px solid #EAECF0"}
            >
              <div style={{ display: "flex" }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_10095_100267)">
                    <path
                      d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                      stroke="#EAECF0"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M20.667 11.6668C21.287 11.6668 21.597 11.6668 21.8513 11.735C22.5415 11.9199 23.0806 12.459 23.2655 13.1492C23.3337 13.4035 23.3337 13.7135 23.3337 14.3335V20.4668C23.3337 21.5869 23.3337 22.147 23.1157 22.5748C22.9239 22.9511 22.618 23.2571 22.2416 23.4488C21.8138 23.6668 21.2538 23.6668 20.1337 23.6668H15.867C14.7469 23.6668 14.1868 23.6668 13.759 23.4488C13.3827 23.2571 13.0767 22.9511 12.885 22.5748C12.667 22.147 12.667 21.5869 12.667 20.4668V14.3335C12.667 13.7135 12.667 13.4035 12.7351 13.1492C12.9201 12.459 13.4592 11.9199 14.1494 11.735C14.4037 11.6668 14.7137 11.6668 15.3337 11.6668M16.4003 13.0002H19.6003C19.9737 13.0002 20.1604 13.0002 20.303 12.9275C20.4284 12.8636 20.5304 12.7616 20.5943 12.6362C20.667 12.4935 20.667 12.3069 20.667 11.9335V11.4002C20.667 11.0268 20.667 10.8401 20.5943 10.6975C20.5304 10.5721 20.4284 10.4701 20.303 10.4062C20.1604 10.3335 19.9737 10.3335 19.6003 10.3335H16.4003C16.027 10.3335 15.8403 10.3335 15.6977 10.4062C15.5722 10.4701 15.4702 10.5721 15.4063 10.6975C15.3337 10.8401 15.3337 11.0268 15.3337 11.4002V11.9335C15.3337 12.3069 15.3337 12.4935 15.4063 12.6362C15.4702 12.7616 15.5722 12.8636 15.6977 12.9275C15.8403 13.0002 16.027 13.0002 16.4003 13.0002Z"
                      stroke="#344054"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10095_100267"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10095_100267"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10095_100267"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>

              <Typography fontSize={"19px"} fontWeight={700} color={"#101828"}>
                {"Overall Assessment"}
              </Typography>
            </CommonGrid2>

            <FeedbackCard
              message={
                "Zahir Mays is a force multiplier for this strategic objective—his clarity of vision and customer obsession significantly increase the likelihood that Macy’s delivers a differentiated, future-proof digital experience. His impact is strongest when complemented by execution-focused leaders who can translate ambition into scalable, on-time delivery."
              }
              icon={<CheckIco />}
              marginBottom="16px"
            />
          </CustomDiv>
        </CommonGrid2>
        <CommonGrid2 size={12}>
          <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              padding={"7px"}
              borderBottom={"1px solid #EAECF0"}
            >
              <div style={{ display: "flex" }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_10095_100267)">
                    <path
                      d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                      stroke="#EAECF0"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M20.667 11.6668C21.287 11.6668 21.597 11.6668 21.8513 11.735C22.5415 11.9199 23.0806 12.459 23.2655 13.1492C23.3337 13.4035 23.3337 13.7135 23.3337 14.3335V20.4668C23.3337 21.5869 23.3337 22.147 23.1157 22.5748C22.9239 22.9511 22.618 23.2571 22.2416 23.4488C21.8138 23.6668 21.2538 23.6668 20.1337 23.6668H15.867C14.7469 23.6668 14.1868 23.6668 13.759 23.4488C13.3827 23.2571 13.0767 22.9511 12.885 22.5748C12.667 22.147 12.667 21.5869 12.667 20.4668V14.3335C12.667 13.7135 12.667 13.4035 12.7351 13.1492C12.9201 12.459 13.4592 11.9199 14.1494 11.735C14.4037 11.6668 14.7137 11.6668 15.3337 11.6668M16.4003 13.0002H19.6003C19.9737 13.0002 20.1604 13.0002 20.303 12.9275C20.4284 12.8636 20.5304 12.7616 20.5943 12.6362C20.667 12.4935 20.667 12.3069 20.667 11.9335V11.4002C20.667 11.0268 20.667 10.8401 20.5943 10.6975C20.5304 10.5721 20.4284 10.4701 20.303 10.4062C20.1604 10.3335 19.9737 10.3335 19.6003 10.3335H16.4003C16.027 10.3335 15.8403 10.3335 15.6977 10.4062C15.5722 10.4701 15.4702 10.5721 15.4063 10.6975C15.3337 10.8401 15.3337 11.0268 15.3337 11.4002V11.9335C15.3337 12.3069 15.3337 12.4935 15.4063 12.6362C15.4702 12.7616 15.5722 12.8636 15.6977 12.9275C15.8403 13.0002 16.027 13.0002 16.4003 13.0002Z"
                      stroke="#344054"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10095_100267"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10095_100267"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10095_100267"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>

              <Typography fontSize={"19px"} fontWeight={700} color={"#101828"}>
                {"Role Summary & Contribution to Objective Success"}
              </Typography>
            </CommonGrid2>
            <FeedbackCard
              message={
                "Zahir Mays serves as the Visionary and Strategic Lead, accountable for defining the future-state customer experience and ensuring the 2026 digital objective remains anchored to long-term customer value and brand differentiation. He translates macro trends, customer insights, and competitive signals into a clear strategic narrative that guides product, technology, and execution teams. Zahir’s contribution is most critical in setting direction, aligning stakeholders, and preventing execution from drifting into incremental or internally focused solutions."
              }
              icon={<CheckIco />}
              marginBottom="16px"
            />
          </CustomDiv>
        </CommonGrid2>

        {/* Area of Focus */}
        <CommonGrid2 size={12}>
          <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              padding={"7px"}
              borderBottom={"1px solid #EAECF0"}
            >
              <div style={{ display: "flex" }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_10095_100267)">
                    <path
                      d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                      stroke="#EAECF0"
                      shape-rendering="crispEdges"
                    />
                    <path
                      d="M20.667 11.6668C21.287 11.6668 21.597 11.6668 21.8513 11.735C22.5415 11.9199 23.0806 12.459 23.2655 13.1492C23.3337 13.4035 23.3337 13.7135 23.3337 14.3335V20.4668C23.3337 21.5869 23.3337 22.147 23.1157 22.5748C22.9239 22.9511 22.618 23.2571 22.2416 23.4488C21.8138 23.6668 21.2538 23.6668 20.1337 23.6668H15.867C14.7469 23.6668 14.1868 23.6668 13.759 23.4488C13.3827 23.2571 13.0767 22.9511 12.885 22.5748C12.667 22.147 12.667 21.5869 12.667 20.4668V14.3335C12.667 13.7135 12.667 13.4035 12.7351 13.1492C12.9201 12.459 13.4592 11.9199 14.1494 11.735C14.4037 11.6668 14.7137 11.6668 15.3337 11.6668M16.4003 13.0002H19.6003C19.9737 13.0002 20.1604 13.0002 20.303 12.9275C20.4284 12.8636 20.5304 12.7616 20.5943 12.6362C20.667 12.4935 20.667 12.3069 20.667 11.9335V11.4002C20.667 11.0268 20.667 10.8401 20.5943 10.6975C20.5304 10.5721 20.4284 10.4701 20.303 10.4062C20.1604 10.3335 19.9737 10.3335 19.6003 10.3335H16.4003C16.027 10.3335 15.8403 10.3335 15.6977 10.4062C15.5722 10.4701 15.4702 10.5721 15.4063 10.6975C15.3337 10.8401 15.3337 11.0268 15.3337 11.4002V11.9335C15.3337 12.3069 15.3337 12.4935 15.4063 12.6362C15.4702 12.7616 15.5722 12.8636 15.6977 12.9275C15.8403 13.0002 16.027 13.0002 16.4003 13.0002Z"
                      stroke="#344054"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10095_100267"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10095_100267"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10095_100267"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>

              <Typography fontSize={"19px"} fontWeight={700} color={"#101828"}>
                {"Areas of Focus"}
              </Typography>
            </CommonGrid2>
            <ul style={{ marginTop: "10px" }}>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Define and continuously refine the customer-first vision for
                Macy’s digital ecosystem
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Establish strategic guardrails and success metrics aligned to
                customer lifetime value
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Align executive stakeholders across product, tech, marketing,
                and stores
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Identify strategic trade-offs (speed vs. quality,
                personalization vs. privacy, build vs. buy)
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Ensure roadmap decisions reflect future-state differentiation,
                not just near-term delivery
              </li>
            </ul>
          </CustomDiv>
        </CommonGrid2>

        {/* Gap Skill */}
        <CommonGrid2 size={12}>
          <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              padding={"7px"}
              borderBottom={"1px solid #EAECF0"}
            >
              <div style={{ display: "flex" }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_10095_100273)">
                    <path
                      d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                      stroke="#EAECF0"
                      shape-rendering="crispEdges"
                    />
                    <g clip-path="url(#clip0_10095_100273)">
                      <path
                        d="M19.9997 15.0002L15.9997 19.0002M15.9997 15.0002L19.9997 19.0002M24.6663 17.0002C24.6663 20.6821 21.6816 23.6668 17.9997 23.6668C14.3178 23.6668 11.333 20.6821 11.333 17.0002C11.333 13.3183 14.3178 10.3335 17.9997 10.3335C21.6816 10.3335 24.6663 13.3183 24.6663 17.0002Z"
                        stroke="#344054"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10095_100273"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10095_100273"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10095_100273"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_10095_100273">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(10 9)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <Typography fontSize={"19px"} fontWeight={700} color={"#101828"}>
                {"Red Flags"}
              </Typography>
            </CommonGrid2>

            <ul style={{ marginTop: "10px" }}>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                <b style={{ fontWeight: 700 }}>Limited execution muscle — </b>{" "}
                excels at defining customer experience strategy but shows gaps
                in driving end-to-end delivery, including prioritization,
                sequencing, and execution rigor.
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                <b style={{ fontWeight: 700 }}>
                  Insufficient operational depth —
                </b>{" "}
                may underweight system constraints, resourcing realities, and
                rollout complexity when shaping CX initiatives.
              </li>
            </ul>
          </CustomDiv>
        </CommonGrid2>

        {/* Recommendations */}
        <CommonGrid2 size={12}>
          <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
            <CommonGrid2
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              padding={"7px"}
              borderBottom={"1px solid #EAECF0"}
            >
              <div style={{ display: "flex" }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_10095_100279)">
                    <path
                      d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                      stroke="#EAECF0"
                      shape-rendering="crispEdges"
                    />
                    <g clip-path="url(#clip0_10095_100279)">
                      <path
                        d="M19.9997 15.0002L15.9997 19.0002M15.9997 15.0002L19.9997 19.0002M24.6663 17.0002C24.6663 20.6821 21.6816 23.6668 17.9997 23.6668C14.3178 23.6668 11.333 20.6821 11.333 17.0002C11.333 13.3183 14.3178 10.3335 17.9997 10.3335C21.6816 10.3335 24.6663 13.3183 24.6663 17.0002Z"
                        stroke="#344054"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_10095_100279"
                      x="0"
                      y="0"
                      width="36"
                      height="36"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_10095_100279"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_10095_100279"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_10095_100279">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(10 9)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <Typography fontSize={"19px"} fontWeight={700} color={"#101828"}>
                {"Succession Readiness"}
              </Typography>
            </CommonGrid2>

            <ul style={{ marginTop: "10px" }}>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                <b style={{ fontWeight: 700 }}>Ready-now </b>for broader
                enterprise strategy roles (Chief Strategy Officer–type scope)
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                <b style={{ fontWeight: 700 }}>1–2 years from readiness</b> for
                full P&L leadership pending deeper operational exposure
              </li>
              <li style={{ color: "#344054", fontSize: "15px" }}>
                Would benefit from {" "}
                <b style={{ fontWeight: 700 }}>
                  rotation into operational ownership 
                </b>
                (e.g., omnichannel or store-linked initiatives)
              </li>
            </ul>
          </CustomDiv>
        </CommonGrid2>
      </CommonGrid2>
    </Box>
  );
}

export default MatchingSummary;
